import { createFileRoute } from "@tanstack/react-router";
import ThankYouContact from "@/pages/ThankYouContact";

export const Route = createFileRoute("/thank-you/contact")({
  component: ThankYouContact,
});
